export const flightInformation = [
  'From City',
  'To Country',
  'To City',
  'Date',
  'Pref. Time',
  'Pref. Airline',
  'Class',
  'Traveller',
];
